const isDev = /\.local$/.test(window.location.host) || process.env.NODE_ENV === 'development';
export const API_URL = isDev ? '//repopul8.circul8.local/api' : 'https://repopul8.circul8.com.au/api';
export const CAMPAIGN_ID = isDev ? '5a66cc61d3d149de26c4b23b' : '5a729da47bc882c9ba2e9bed';



// WEBPACK FOOTER //
// ./src/constants.js